var _sodipodiNamedview, _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 200,
    viewBox: "0 0 200 1250",
    id: "svg5",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview7",
    pagecolor: "#505050",
    bordercolor: "#eeeeee",
    borderopacity: 1,
    showgrid: "false"
  })), /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient10760"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#536c5d",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop10756"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#536c5d",
      stopOpacity: 0
    },
    offset: 1,
    id: "stop10758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient8247"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#6f916f",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop8243"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#6f916f",
      stopOpacity: 0
    },
    offset: 1,
    id: "stop8245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient346"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#55ffdd",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop342"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#55ffdd",
      stopOpacity: 0
    },
    offset: 1,
    id: "stop344"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient338"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#55ffdd",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop334"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#55ffdd",
      stopOpacity: 0
    },
    offset: 1,
    id: "stop336"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient330"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#55ffdd",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop326"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#55ffdd",
      stopOpacity: 0
    },
    offset: 1,
    id: "stop328"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient330",
    id: "linearGradient332",
    x1: 40.915154,
    y1: 129.57236,
    x2: 139.1109,
    y2: 86.906952,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.69269245,0,0,2.084801,15.558046,-109.01819)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient338",
    id: "linearGradient340",
    x1: 88.040916,
    y1: 37.588753,
    x2: 141.46664,
    y2: 110.19019,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.67002426,0,0,1.7057111,30.006137,-47.649729)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient346",
    id: "linearGradient348",
    x1: 32.470509,
    y1: 54.054344,
    x2: 102.60065,
    y2: 62.657681,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.83385475,0,0,1.6104607,12.367258,-48.239566)"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient346",
    id: "linearGradient5700",
    x1: 100,
    y1: 687.5,
    x2: 100,
    y2: 625,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.2552912,0,0,1.1945521,-413.65611,-220.08279)"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient8247",
    id: "linearGradient8249",
    x1: -268.75,
    y1: 475,
    x2: -300,
    y2: 450,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient10760",
    id: "linearGradient10762",
    x1: -281.25,
    y1: 493.75,
    x2: -312.5,
    y2: 487.5,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient10760",
    id: "linearGradient10950",
    gradientUnits: "userSpaceOnUse",
    x1: -281.25,
    y1: 493.75,
    x2: -312.5,
    y2: 487.5,
    gradientTransform: "translate(-30.74035,25)"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient346",
    id: "linearGradient13011",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.6198742,0,0,1.5414942,-436.65789,-433.63993)",
    x1: 100,
    y1: 687.5,
    x2: 100,
    y2: 625
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient346",
    id: "linearGradient13136",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.4046299,0,0,1.3366649,-412.44217,-257.46938)",
    x1: 100,
    y1: 687.5,
    x2: 100,
    y2: 625
  }))), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#3771c8",
      fillRule: "evenodd",
      strokeWidth: 6.94445
    },
    id: "path127",
    cx: 100,
    cy: 625,
    r: 312.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      fill: "#00aa44",
      strokeWidth: 6.4651,
      InkscapeStroke: "none"
    },
    d: "m -11.486324,432.49954 c 2e-6,27.41266 -33.637201,53.0362 -61.049865,53.0362 -27.412664,0 -105.467751,19.34345 -95.560971,-11.34113 C -156.25,437.5 -112.5,381.25 -71.033157,378.49918 c 31.700814,-2.10295 59.546835,26.5877 59.546833,54.00036 z",
    id: "path362"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      fill: "#00aa44",
      strokeWidth: 6.4651,
      InkscapeStroke: "none"
    },
    d: "m 18.602148,718.88085 c -1.473145,27.37305 -78.324502,62.00417 -105.737166,62.00417 -27.412662,0 -94.114982,62.86498 -109.661972,-58.22766 -4.1061,-31.98166 62.14175,-18.71515 83.28331,-48.9069 C -75,618.75 25,600 18.602148,718.88085 Z",
    id: "path362-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      fill: "#00aa44",
      strokeWidth: 6.4651,
      InkscapeStroke: "none"
    },
    d: "m 350,812.5 c -19.38368,19.38368 -83.21258,19.21839 -110.62525,19.21839 -27.41266,0 -167.394374,6.71382 -87.94053,-85.98042 34.58805,-40.35189 70.64043,-27.70256 108.40765,-19.43091 C 325.43146,740.67226 443.75,718.75 350,812.5 Z",
    id: "path362-3-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      fill: "#00aa44",
      strokeWidth: 6.4651,
      InkscapeStroke: "none"
    },
    d: "m 318.75,500 c 71.23686,50.41293 2.39177,129.53989 -24.90617,127.0344 C 139.98686,612.91293 97.632363,595.10819 82.085371,474.01555 77.979271,442.03389 128.14939,426.8085 148.75659,396.24953 171.23686,362.91293 221.57002,431.22762 318.75,500 Z",
    id: "path362-3-6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "none",
      fillOpacity: 0.64711,
      stroke: "url(#linearGradient5700)",
      strokeWidth: 3.06136,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      paintOrder: "markers fill stroke"
    },
    id: "path5447",
    ry: 37.329754,
    rx: 470.73425,
    cy: 563.84198,
    cx: -288.12692,
    transform: "matrix(0.82532128,-0.56466342,0.57317601,0.81943228,0,0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "none",
      fillOpacity: 0.64711,
      stroke: "url(#linearGradient13011)",
      strokeWidth: 3.9505,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      paintOrder: "markers fill stroke"
    },
    id: "path5447-2",
    ry: 48.171692,
    rx: 607.45288,
    cy: 577.96552,
    cx: -274.67038,
    transform: "matrix(0.82532128,-0.56466342,0.57317601,0.81943228,0,0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "none",
      fillOpacity: 0.64711,
      stroke: "url(#linearGradient13136)",
      strokeWidth: 3.42557,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      paintOrder: "markers fill stroke"
    },
    id: "path5447-2-8",
    ry: 41.770775,
    rx: 526.73633,
    cy: 619.71686,
    cx: -271.9791,
    transform: "matrix(0.82532128,-0.56466342,0.57317601,0.81943228,0,0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#linearGradient8249)",
      fillOpacity: 1,
      strokeWidth: 2.99407,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      paintOrder: "markers fill stroke"
    },
    id: "path7720",
    cx: -300.38971,
    cy: 534.6391,
    rx: 41.080814,
    ry: 41.256214
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    d: "m -337.5,518.75 v 0 h 12.5 v -6.25 l -6.25,-6.25 z",
    id: "path8795"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      fill: "#536c5d",
      strokeWidth: 0,
      InkscapeStroke: "none",
      paintOrder: "markers fill stroke",
      fillOpacity: 1
    },
    d: "m -311.71455,523.32572 c 0,3.45178 -7.03545,1.67428 -12.91146,3.30589 -3.32594,0.92352 -9.14598,-1.37638 -9.14598,-4.82816 0,-3.45178 8.79448,-0.97782 12.24626,-0.97782 3.45178,0 9.81118,-0.95169 9.81118,2.50009 z",
    id: "path9213"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      fill: "url(#linearGradient10762)",
      fillOpacity: 1,
      strokeWidth: 0,
      InkscapeStroke: "none",
      paintOrder: "markers fill stroke"
    },
    d: "m -263.00965,531.25 c 2.97579,4.42568 -4.46195,23.88243 -23.86235,12.26704 -3.35901,-2.01111 -16.75972,3.15972 -16.75972,-5.57399 0,-8.73371 3.63172,-31.04403 15.47536,-18.40547 6.46776,6.90184 19.40636,3.17523 25.14671,11.71242 z",
    id: "path9213-5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      fill: "url(#linearGradient10950)",
      strokeWidth: 0,
      InkscapeStroke: "none",
      paintOrder: "markers fill stroke"
    },
    d: "m -316.8356,551.14843 c 4.3845,2.63022 13.85489,5.9406 10.96861,9.64334 -2.70664,3.47228 -2.35672,13.34645 -11.74536,7.72527 -0.73905,-0.44249 -1.13765,0.23296 -6.02337,-1.67009 -5.09538,-1.98472 -5.90539,-3.13077 -7.24959,-4.62901 -0.52113,-0.58085 -0.95194,-1.05818 -1.67848,-1.93356 -0.40422,-0.48703 1.31379,2.21562 -1.36849,-1.94447 -4.73272,-7.34023 -3.75804,-2.39601 5.59945,-6.77888 C -325,550 -318.75,550 -316.8356,551.14843 Z",
    id: "path9213-5-6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ccffaa",
      fillOpacity: 1,
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      paintOrder: "markers fill stroke"
    },
    id: "path12216",
    d: "M 165,95 164.57574,90.424264 160,90 164.57574,89.575736 165,85 165.42426,89.575736 170,90 l -4.57574,0.424264 z",
    transform: "matrix(6.25,0,0,6.25,-525,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ccffaa",
      fillOpacity: 1,
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      paintOrder: "markers fill stroke"
    },
    id: "path12216-2",
    transform: "matrix(6.25,0,0,6.25,-741.09835,-278.59835)",
    d: "M 165,95 164.57574,90.424264 160,90 164.57574,89.575736 165,85 165.42426,89.575736 170,90 l -4.57574,0.424264 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ccffaa",
      fillOpacity: 1,
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      paintOrder: "markers fill stroke"
    },
    id: "path12216-9",
    transform: "matrix(6.25,0,0,6.25,-1303.5983,153.59835)",
    d: "m 164.57573,100.42426 -0.42426,-4.575733 -4.57574,-0.424264 4.57574,-0.424264 0.42426,-4.575736 0.42426,4.575736 4.57574,0.424264 -4.57574,0.424264 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ccffaa",
      fillOpacity: 1,
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      paintOrder: "markers fill stroke"
    },
    id: "path12216-1",
    transform: "matrix(6.25,0,0,6.25,-1215.1517,466.09835)",
    d: "M 165,95 164.57574,90.424264 160,90 164.57574,89.575736 165,85 165.42426,89.575736 170,90 l -4.57574,0.424264 z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarth);
export default __webpack_public_path__ + "static/media/earth.300aae83e6ec06e9f5fb260beb42009f.svg";
export { ForwardRef as ReactComponent };